module.exports = __webpack_public_path__ + "static/whats-new__hero.091795c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/whats-new__hero.jpg
// module id = 120
// module chunks = 174759553322802 227638899823042